import React, { useEffect, useRef, useState } from 'react';

const KioskCounter = ({ kiosk }) => {
  const [counter, setCounter] = useState(0);
  const interval = useRef(null);

  const add0 = (num) => (num < 10 ? '0' + num : num);

  useEffect(() => {
    const secondsTillNow = (new Date() - new Date(kiosk.started_at)) / 1000;
    setCounter(secondsTillNow);
    clearInterval(interval.current);
    interval.current = setInterval(() => {
      setCounter((counter) => counter + 1);
    }, 1000);
    return () => clearInterval(interval.current);
  }, [kiosk.started_at]);

  const formatCounter = (counter) => {
    const hours = Math.floor(counter / 3600);
    const minutes = Math.floor((counter % 3600) / 60);
    const seconds = Math.floor(counter % 60);
    return `${hours > 0 ? hours + 'h ' : ''}${minutes > 0 ? add0(minutes) + 'm ' : ''}${add0(
      seconds
    )}s`;
  };
  return <p className="text-xs text-neutral-700">{formatCounter(counter)}</p>;
};

export default KioskCounter;
